import PropTypes from "prop-types";
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";

const accentBar = {
  info: "linear-gradient(180deg, #21d4fd 0%, #2152ff 100%)",
  success: "linear-gradient(180deg, #98ec2d 0%, #17ad37 100%)",
  warning: "linear-gradient(180deg, #fbcf33 0%, #f53939 100%)",
  error: "linear-gradient(180deg, #ff667c 0%, #ea0606 100%)",
  primary: "linear-gradient(180deg, #627594 0%, #002054 100%)",
};

function MetricHeroCard({ label, value, sub, accent = "info", icon }) {
  return (
    <Card
      sx={{
        height: "100%",
        position: "relative",
        overflow: "hidden",
        borderRadius: "1.25rem",
        border: "none",
        boxShadow: "0 4px 20px rgba(52, 71, 103, 0.07)",
        transition: "transform 0.2s ease, box-shadow 0.2s ease",
        "&:hover": {
          transform: "translateY(-2px)",
          boxShadow: "0 10px 28px rgba(52, 71, 103, 0.1)",
        },
      }}
    >
      <SoftBox
        position="absolute"
        left={0}
        top={0}
        bottom={0}
        width="4px"
        sx={{ background: accentBar[accent] || accentBar.info }}
      />
      <SoftBox p={3} pl={3.25}>
        <SoftBox display="flex" justifyContent="space-between" alignItems="flex-start" mb={1.75}>
          <SoftTypography
            variant="caption"
            color="text"
            fontWeight="medium"
            sx={{ textTransform: "uppercase", letterSpacing: "0.04em", pr: 1 }}
          >
            {label}
          </SoftTypography>
          <SoftBox
            width="2.25rem"
            height="2.25rem"
            borderRadius="lg"
            display="flex"
            alignItems="center"
            justifyContent="center"
            sx={{
              background: "linear-gradient(135deg, rgba(23, 193, 232, 0.12) 0%, rgba(0, 32, 84, 0.08) 100%)",
            }}
          >
            <Icon sx={{ fontSize: "1.1rem", color: "info.main", opacity: 0.9 }}>{icon}</Icon>
          </SoftBox>
        </SoftBox>
        <SoftTypography variant="h4" fontWeight="bold" color="dark" sx={{ lineHeight: 1.2 }}>
          {value}
        </SoftTypography>
        {sub && (
          <SoftTypography variant="caption" color="secondary" mt={1.25} display="block" sx={{ lineHeight: 1.5 }}>
            {sub}
          </SoftTypography>
        )}
      </SoftBox>
    </Card>
  );
}

MetricHeroCard.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  sub: PropTypes.string,
  accent: PropTypes.oneOf(["info", "success", "warning", "error", "primary"]),
  icon: PropTypes.string.isRequired,
};

export default MetricHeroCard;
